/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Messages = {
    type: 'array',
    contains: {
        type: 'Message',
    },
};